import { FieldError, UseFormRegisterReturn } from 'react-hook-form'
import TextField from '../../atoms/inputs/TextField'

type BankBranchOfficeCodeFieldProps = {
  register?: UseFormRegisterReturn
  error?: FieldError
  disabled?: boolean
}

export default function BankBranchOfficeCodeField({ register, error, disabled }: BankBranchOfficeCodeFieldProps) {
  return (
    <TextField
      register={register}
      placeholder="999"
      size="xs"
      error={error?.message}
      convertToAscii
      readonly={disabled}
    />
  )
}
